import {Component, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-base64-svg',
  templateUrl: './base64-svg.component.html',
  styleUrls: ['./base64-svg.component.scss'],
  standalone: true
})
export class Base64SvgComponent {
  public svgElement: SafeHtml;
  public svgColor: string;

  constructor(private _domSanitizer: DomSanitizer) {
    this.svgElement = '';
    this.svgColor = 'inherit';
  }

  @Input({required: true})
  set base64(value: string) {
    this.svgElement = this._domSanitizer.bypassSecurityTrustHtml(atob(value));
  }

  @Input({required: false})
  set color(value: string | null) {
    this.svgColor = value || 'inherit';
  }
}
